<template>
  <el-table-column
    prop="location"
    sortable="custom"
    label="Terület"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      {{ scope.row.location }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
